module.exports = __webpack_public_path__ + "static/otf-logo-1836148af2695973c6bab1950fd04897.jpg";